exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indented[data-v-14fc86fd]{margin:20px;max-width:550px}.spacer[data-v-14fc86fd]{height:65px;border:0 solid #000}.smallspacer[data-v-14fc86fd]{height:20px;border:0 solid #000}.text-danger[data-v-14fc86fd]{margin-top:10px;color:red}.spaced[data-v-14fc86fd]{margin-bottom:10px}.button[data-v-14fc86fd]{border:1px solid gray}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14fc86fd","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Comp_AddProduct.vue
// module id = 114
// module chunks = 0